import mixpanelImpl from 'mixpanel-browser';
import config, { MIX_PANEL_APP_TYPE } from '../constants/Config';

const token = config.get('MIX_PANEL_API_TOKEN');

const mixpanelAnalyticsFactory = (mixpanel) => {
    const instance = {
        init: (optOutConsent) => {
            mixpanel.init(token, { opt_out_tracking_by_default: optOutConsent });
            window.MixpanelAnalytics = instance;
        },
        enableTracking: () => {
            mixpanel.opt_in_tracking();
        },

        disableTracking: () => {
            mixpanel.opt_out_tracking();
        },

        track: (eventName, extraData) => {
            mixpanel.track(eventName, extraData);
        },

        setUser: (identity) => {
            mixpanel.identify(identity.userName);

            const info = {
                $name: identity.userName,
                $userName: identity.userName,
                $appType: MIX_PANEL_APP_TYPE,
            };

            if (identity.firstName) info.$first_name = identity.firstName;
            if (identity.lastName) info.$last_name = identity.lastName;
            if (identity.accountId) info.$accountId = identity.accountId;
            if (identity.email) info.$email = identity.email;
            if (identity.accountName) info.$accountName = identity.accountName;
            if (identity.userTz) info.$userTz = identity.userTz;
            if (identity.userId) info.$userId = identity.userId;

            mixpanel.people.set(info);
        },
    };

    return instance;
};

export default mixpanelAnalyticsFactory(mixpanelImpl);
